import classNames from "classnames";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import { useActivityFormStore } from "../../activity_form_store";
import css from "./header.module.scss";

type HeaderProps = {
  isSmallScreen: boolean;
};

export const Header = ({ isSmallScreen }: HeaderProps) => {
  const { t } = useTranslation("activities");
  const { isNew } = useActivityFormStore((state) => state.activityStatus);
  const template = useActivityFormStore((state) => state.template);
  const templateName = t(`templates.${template.key}`);

  return (
    <Typography variant="h1" className={classNames(css.pageTitle, { [css.sticky]: !isSmallScreen })}>
      {isNew
        ? t("form.pageTitle.createTemplate", { templateName })
        : t("form.pageTitle.editTemplate", { templateName })}
    </Typography>
  );
};
